import type { Media, Shape, Theme } from '../../types/props'

export type Item = {
  theme?: Theme
  title: string
  description: string
  imageUrl: Media
  imageMobileUrl?: Media
  tabName?: string
  width?: 'full' | 'half' | 'one-third'
  blockLink?: string
  primaryButton: {
    text: string
    link: string
  }
  secondaryButton: {
    text: string
    link: string
  }
  video?: {
    url: string
  }
  youtubeId?: string
  isYouTube?: boolean
  id?: string
}

export type MultiLayoutGraphicBlockProps = React.HTMLAttributes<HTMLElement> & {
  onSecondaryButtonClick?: () => void
  onPrimaryButtonClick?: () => void
  data: {
    shape?: Shape
    sectionTitle?: string
    groupByTab?: boolean
    items: ({
      width?: 'full' | 'half' | 'one-third'
    } & Item)[]
    carousel?: {
      items: Item[]
    }
  }
}
